import React, { useState } from 'react';
import Section from './Section';
import { X_PADDING } from '../constants';
import { CIMedicalInsurance } from './CoazIcons';
import Page from './Page';

const DeliveringCare = () => {
  return (
    <Page name="Delivering Care">
      <div className="w-full pt-8 bg-white">
        <Section
          name="Excellence in Clinical Practice"
          description="COAZ is dedicated to promoting excellence in professional practice within the healthcare sector. We provide resources, guidelines, and support to empower our member healthcare professionals to deliver high-quality care to their patients. Our focus is enhancing a culture of continuous improvement and innovation in healthcare delivery."
        />

        {/* Guidelines & Resources */}
        <Section name="Guidelines and Resources">
          <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ${X_PADDING}`}>
            <GuidelineCard 
              icon={<CIMedicalInsurance size={40} className="text-[#1b9de3]" />}
              title="Standard Treatment Guidelines"
              description="National reference for consistent, evidence-based patient management."
            />
            <GuidelineCard 
              icon={<CIMedicalInsurance size={40} className="text-[#1b9de3]" />}
              title="HIV Treatment Guidelines"
              description="Current protocols for HIV testing, care, and treatment at every level."
            />
            <GuidelineCard 
              icon={<CIMedicalInsurance size={40} className="text-[#1b9de3]" />}
              title="Zambia National Formulary"
              description="Approved medicines list and prescribing reference for clinical officers."
            />
            <GuidelineCard 
              icon={<CIMedicalInsurance size={40} className="text-[#1b9de3]" />}
              title="Other Useful Guidelines"
              description="Additional resources and best practice documents for clinical care."
            />
          </div>
        </Section>

        {/* Health Equity in Zambia */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex flex-col lg:w-2/3 h-fit space-y-8">
              <div className="flex flex-col w-full h-fit space-y-4">
                <h2 className="text-2xl font-bold text-[#16365c]">Health Equity in Zambia</h2>
                <p className="text-[#7c8a97]">
                  COAZ is committed to creating a culturally aware and diverse Clinical Officers' workforce. 
                  Learn more about the COAZ's efforts to drive diversity & inclusion with the latest articles and studies.
                </p>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 w-full h-fit gap-4 overflow-hidden">
                <EquityFeatureCard 
                  title="Health Insurance" 
                  description="Advocating for improved access and coverage for underserved communities." 
                  active={true}
                />
                <EquityFeatureCard 
                  title="Health Care Equity" 
                  description="Scaling equitable-care practice and shaping national policy." 
                />
                <EquityFeatureCard 
                  title="Health Care Disparities" 
                  description="Closing gaps by geography, income, ethnicity, and gender." 
                />
                <EquityFeatureCard 
                  title="Cultural Humility" 
                  description="Equipping providers to care across cultural backgrounds." 
                />
              </div>
            
            </div>

            {/* Right side */}
            <div className="lg:w-1/3 bg-[#eef7fd] rounded-lg p-6 shadow-sm">
              <div className="h-32 rounded-md mb-4 overflow-hidden">
                <img
                  //change image
                  src="/images/img_55.jpg"
                  alt="Health Insurance Advocay"
                  ClassName="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-lg font-bold text-[#16365c] mb-2">Health Insurance Advocacy</h3>
              <p className="text-[#7c8a97] text-sm mb-4">
                Zambia’s current state of the National health insurance access presents various challenges, particularly for those in underserved areas. 
                Many people in these communities either lack access to health insurance entirely or face significant barriers to enrollment due to factors 
                such as poverty, lack of awareness, and limited availability of insurance services.
              </p>
              <p className="text-[#7c8a97] text-sm mb-4">
                Under the theme "Improving National Health Insurance Access for Underserved Communities," COAZ advocates for wider NHIMA coverage, affordability, quality services, health education, and community participation.
              </p>
              <button className="bg-[#1477c2] text-white px-5 py-2 rounded-full text-sm font-semibold hover:bg-[#16365c] transition">
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* Health Care Disparities Section */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="bg-white border border-[#eef1f4] rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#16365c] mb-2">HEALTH CARE DISPARITIES</h3>
            <p className="text-[#7c8a97]">
              Our mission for health equity in Zambia starts with recognizing disparities in healthcare access, especially for underserved communities. 
              We focus on areas like geography, income, ethnicity, and gender to tailor our efforts effectively. We work closely with community, civic leaders 
              and healthcare providers to spread awareness about the importance of health insurance, and health service distribution particularly in regions with limited coverage.
            </p>
            <p className="text-[#7c8a97] mt-4">
              We advocate for policy changes to expand National Health Insurance (NHI) coverage to essential services and remove barriers to enrollment. 
              Our aim is to address underlying issues like poverty, education, and housing that contribute to health disparities. We track progress through 
              data collection and collaborate with government agencies, NGOs, and healthcare providers to amplify our impact.
            </p>
          </div>
        </div>

        {/* Cultural Humility Section */}
        <div className={`${X_PADDING} w-full mx-auto pb-12`}>
          <div className="bg-white border border-[#eef1f4] rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#16365c] mb-2">CULTURAL HUMILITY IN HEALTHCARE</h3>
            <p className="text-[#7c8a97]">
              The ability to communicate and empathize with patients plays a crucial role in delivering quality care. Here's how the COAZ is promoting cultural humility in health care. 
              Addresses health disparities and inequities by understanding specific healthcare needs of diverse populations. COAZ collaborates with community organizations and leaders, 
              promotes policies that prioritize workforce diversity, providing resources and workshops on cultural competence, and equips healthcare providers with the skills needed 
              to communicate effectively and empathize with patients from various cultural backgrounds.
            </p>
          </div>
        </div>

        {/* Disease Discussion Hubs */}
        <div className="py-12">
          <div className={`${X_PADDING} w-full mx-auto`}>
            <div className="text-center mb-10">
              <h2 className="text-2xl font-bold text-[#16365c]">Disease Discussion Hubs</h2>
              <p className="text-[#7c8a97] mt-2 max-w-2xl mx-auto">
                Click on each topic to start or join discussions.
              </p>
              <div className="w-16 h-1 bg-[#1f8fd1] mx-auto mt-4 rounded"></div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Communicable Diseases */}
              <div>
                <h3 className="text-base font-semibold text-[#1f8fd1] mb-4"> Communicable Diseases</h3>
                <div className="grid grid-cols-2 gap-4">
                  <DiseaseHubItem title="Tuberculosis" />
                  <DiseaseHubItem title="HIV / AIDS" />
                  <DiseaseHubItem title="COVID-19"/>
                  <DiseaseHubItem title="Cholera" />
                  <DiseaseHubItem title="Malaria" />
                  <DiseaseHubItem title="Hepatitis B" />
                </div>
              </div>

              {/* Non-Communicable Diseases */}
              <div>
                <h3 className="text-base font-semibold text-[#1f8fd1] mb-4"> Non-Communicable Diseases</h3>
                <div className="grid grid-cols-2 gap-4">
                  <DiseaseHubItem title="Cervical Cancer"/>
                  <DiseaseHubItem title="Prostate Cancer" />
                  <DiseaseHubItem title="Breast Cancer"/>
                  <DiseaseHubItem title="Hypertension"/>
                  <DiseaseHubItem title="Heart Failure"/>
                  <DiseaseHubItem title="Congenital Heart"/>
                  <DiseaseHubItem title="Kidney Failure"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="bg-[#1477c2] py-10">
          <div className={`${X_PADDING} w-full mx-auto flex flex-col md:flex-row items-center justify-between gap-4`}>
            <h2 className="text-white text-2xl font-semibold">You Always Get the Best Guidance</h2>
            <button className="bg-white text-[#1477c2] px-8 py-3 rounded-full font-semibold hover:bg-[#eef7fd] transition">
              Join the Discussion
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default DeliveringCare;

const GuidelineCard = ({ icon, title, description }) => {
  const [hover, setHover] = useState(false);

  return (
    <div 
      className="border border-[#eef1f4] rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="h-32 bg-[#eef7fd] flex items-center justify-center">
        <div className={`p-3 rounded-full transition-colors ${hover ? 'bg-white' : 'bg-[#eef7fd]'}`}>
          <div className={hover ? 'text-white' : 'text-[#1b9de3]'}>
            {icon}
          </div>
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-bold text-[#16365c] text-sm mb-2">{title}</h3>
        <p className="text-[#7c8a97] text-xs mb-3">{description}</p>
        <button className="text-[#1477c2] text-xs font-semibold hover:text-[#16365c] transition">
          Read More →
        </button>
      </div>
    </div>
  );
};

const EquityFeatureCard = ({ title, description }) => {
  const [highlighted, setHighlighted] = useState(false);

  return (
    <div className="w-full h-48">
      <div 
        onMouseEnter={() => setHighlighted(true)}
        onMouseLeave={() => setHighlighted(false)}
        className={`feature  flex flex-col space-y-2 items-center p-6 hover:text-white overflow-hidden rounded-lg transition-all duration-300 ${
          highlighted ? 'bg-[#1477c2] text-white shadow-md' : 'bg-[#eef7fd] text-[#16365c]'
        }`}
      >
        <h4 className={`text-base font-bold text-center transition-colors duration-300 ${
           highlighted ? 'text-white' : 'text-[#16365c]'
        }`}>
          {title}
        </h4>
        <p className={`text-xs text-center transition-colors duration-300 ${
           highlighted ? 'text-white/85' : 'text-[#7c8a97]'
        }`}>
          {description}
        </p>
      </div>
    </div>
  );
};

const DiseaseHubItem = ({ title }) => {
  const [hover, setHover] = useState(false);

  const getDescription = (title) => {
    const descriptions = {
      "Tuberculosis": "Tuberculosis (TB) is an infectious disease that most often affects the lungs. TB is caused by a type of bacteria that spreads through the air when infected people cough, sneeze, or spit.",
      "HIV / AIDS": "Acquired immunodeficiency syndrome (AIDS) is a chronic, potentially life-threatening condition caused by the human immunodeficiency virus (HIV)",
      "COVID-19": "Coronaviruses are a family of viruses that cause illness ranging from the common cold to potentially severe diseases such as COVID-19 and Severe Acute Respiratory Syndrome (SARS)",
      "Cholera": "An acute diarrheal infection caused by ingesting food or water contaminated with the bacterium Vibrio cholerae.",
        "Malaria": "A life-threatening disease caused by parasites that are transmitted to people through the bites of infected female",
        "Hepatitis B": "A serious liver infection caused by the hepatitis B virus (HBV) that can become chronic, leading to liver failure, cancer, or cirrhosis.",
        "Cervical Cancer": "A type of cancer that occurs in the cells of the cervix — the lower part of the uterus that connects to the",
        "Prostate Cancer": "A form of cancer that develops in the prostate, a small walnut",
      "Breast Cancer": "A type of cancer that forms in the cells of the breasts, often detected through lumps or changes in breast tissue.",
      "Hypertension": "A condition in which the force of the blood against the artery walls is too high, often leading to heart disease and stroke.",
      "Heart Failure": "A chronic condition in which the heart doesn't pump blood as well as it should, leading to fatigue, shortness of breath, and fluid retention.",
      "Congenital Heart": "A defect in the structure of the heart and great vessels that is present at birth, which can affect the heart's ability to pump blood effectively.",
      "Kidney Failure": "A condition in which the kidneys lose the ability to filter waste from the blood, leading to a dangerous buildup of toxins in the body."
    };
    return descriptions[title] || "Join the discussion on this topic.";
  };

 return (
    <div 
      className="p-4 border border-[#eef1f4] rounded-lg hover:shadow-md transition-shadow cursor-pointer group"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => console.log(`Navigate to ${title} discussion hub`)}
    >
      <h4 className={`text-sm font-semibold transition-colors ${
        hover ? 'text-[#1477c2]' : 'text-[#16365c]'
      }`}>
        {title}
      </h4>
      <p className="text-xs text-[#7c8a97] mt-1 line-clamp-2">
        {getDescription(title)}
      </p>
      <div className={`mt-2 text-xs font-medium transition-colors ${
        hover ? 'text-[#1477c2]' : 'text-[#7c8a97]'
      }`}>
        Join Discussion →
      </div>
    </div>
  );
};